export default __webpack_public_path__ + "media/zurb/img/playground/success-icon-1a88f3c3e6a1f8a0d310d5a39b3075c5.svg";